import { Avatar, Card, Col, Row, Space, Tag } from 'antd';
import { OrderProducts } from '../../../uiComponents/OrderProducts';
import DefaultImage from '../../../../assets/images/ICONO-AZUL-100x100.png';
import './styles.css';
import { treatmentConst } from '../../../../constants/Treatments.cons';
import { label } from '../../../../constants/Forms';
import { formatPrice } from '../../../../util/formatPrice';
import { slugConst } from '../../../../constants/Slug.const';

export const TreatmentModal = ({ data = {} }) => {
  const treatmentTypeMedical = data?.treatmentType?.name;

  const showTerm = (term) => {
    const [hr, minutes] = term.split(':');
    const hrs = hr > 0 ? `${hr} : ${minutes} hora(s)` : ` ${minutes} minutos`;

    return hrs;
  };

  const formatValidity = (validity) => {
    if (!validity && validity !== 0) return '-';

    return `${validity} día${validity !== 1 ? 's' : ''}`;
  };

  return (
    <>
      <Card
        bordered={false}
        cover={
          <Avatar
            className="avatar"
            alt="..."
            src={
              data?.photo
                ? `${process.env.REACT_APP_API}/v1/photo/thumbnail/${data?.photo?.name}`
                : DefaultImage
            }
          />
        }
        style={{ marginBottom: '0px' }}
      ></Card>
      <Row className="row">
        <Col span={8}>
          <h4>{label.treatmentType}</h4>
        </Col>
        <Col span={16}>{data?.treatmentType?.name || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{label.sku}</h4>
        </Col>
        <Col span={16}>{data?.sku || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{slugConst.label}</h4>
        </Col>
        <Col span={16}>{data?.slug || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{label.description}</h4>
        </Col>
        <Col span={16}>{data?.description || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{label.category}</h4>
        </Col>
        <Col span={16}>
          {' '}
          <Space wrap>
            {data?.categories?.map((category) => (
              <Tag key={category.id}>{category.name}</Tag>
            ))}
          </Space>
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{label.relatedTreatments}</h4>
        </Col>
        <Col span={16}>
          {data?.relatedTreatments?.length > 0 ? (
            <Space wrap>
              {data.relatedTreatments.map((relatedTreatment) => (
                <Tag key={relatedTreatment.id}>
                  {`${relatedTreatment.sku} - ${relatedTreatment.name}`}
                </Tag>
              ))}
            </Space>
          ) : (
            '-'
          )}
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{label.validity}</h4>
        </Col>
        <Col span={16}>{formatValidity(data?.validity)}</Col>
      </Row>

      {data?.areas?.length > 0 && (
        <Row className="row">
          <Col span={8}>
            <h4>{label.areas}</h4>
          </Col>
          <Col span={16}>
            {' '}
            <Space wrap>
              {data?.areas?.map((area) => (
                <Tag key={area.id}>{area.name}</Tag>
              ))}
            </Space>
          </Col>
        </Row>
      )}

      {data?.appliance?.length > 0 && (
        <Row className="row">
          <Col span={8}>
            <h4>{label.appliances}</h4>
          </Col>
          <Col span={16}>
            <Space wrap>
              {data?.appliance?.map((app) => (
                <Tag key={app.id}>{app.name}</Tag>
              ))}
            </Space>
          </Col>
        </Row>
      )}

      <Row className="row">
        <Col span={8}>
          <h4>{label.requiresAssessment}</h4>
        </Col>
        <Col span={16}>
          {data?.assessment ? label.yesText : label.noText}
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{label.requiresConsent}</h4>
        </Col>
        <Col span={16}>{data?.consent ? label.yesText : label.noText}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{label.price}</h4>
        </Col>
        <Col span={16}>{formatPrice(data?.price) || '-'}</Col>
      </Row>
      {treatmentTypeMedical === treatmentConst.medical && (
        <Row className="row">
          <Col span={8}>
            <h4>{label.medicalCommission}</h4>
          </Col>
          <Col span={16}>{`${formatPrice(data?.medicalFee)}`}</Col>
        </Row>
      )}

      <Row className="row">
        <Col span={8}>
          <h4>{label.points}</h4>
        </Col>
        <Col span={16}>{data?.points || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{label.duration}</h4>
        </Col>
        <Col span={16}>{showTerm(data?.term) || '-'}</Col>
      </Row>

      {data?.treatmentProduct?.length > 0 && (
        <OrderProducts
          orderProducts={data?.treatmentProduct}
          orderType="treatment"
          span={12}
        />
      )}
    </>
  );
};
